// src/shared/modules/admin/ResetPassword.tsx
import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
// @ts-ignore: allow side-effect CSS import without module declarations
import "react-toastify/dist/ReactToastify.css";
import { notifyError, notifySuccess } from "../../../assets/toastService";
import CommonTextField from "../../components/CommonTextField";
import CommonButtons from "../../components/CommonButtons";
import { usePasswordValidation } from "../../hooks/usePasswordValidation";
import PasswordFieldWithValidation from "./PasswordFieldWithValidation";
import { resetPassword } from "../../services/services";

const ResetPassword: React.FC = () => {
  const { token } = useParams<{ token: string }>();
  const navigate = useNavigate();

  const [newPassword, setNewPassword] = useState<string>("");
  const [confirmPassword, setConfirmPassword] = useState<string>("");

  // run validation for newPassword
  const validation = usePasswordValidation(newPassword);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!token) {
      notifyError("Invalid or missing reset token");
      return;
    }
    if (!validation.isValid) {
      notifyError("Please fix the password errors before submitting");
      return;
    }
    if (newPassword !== confirmPassword) {
      notifyError("Passwords do not match");
      return;
    }

    try {
      await resetPassword(token, newPassword, confirmPassword);
      notifySuccess("Password reset successful");
      setTimeout(() => navigate("/"), 1500);
    } catch (error) {
      console.error(error);
      notifyError("An error occurred");
    }
  };

  return (
    <div className='min-h-screen w-screen bg-[#EEF4F7] flex items-center justify-center'>
      <div className='w-full max-w-md bg-white rounded-xl shadow-md p-6'>
        <h1 className='text-2xl font-semibold mb-2'>Reset Password</h1>
        <p className='text-sm text-gray-600 mb-6'>Enter and confirm your new password.</p>

        <form onSubmit={handleSubmit} className='space-y-4'>
          {/* ✅ New Password with validation */}
          <PasswordFieldWithValidation label='New Password' value={newPassword} placeholder='Enter your new password' onChange={setNewPassword} />
          {/* ✅ Confirm Password (simple check) */}
          <CommonTextField
            label='Confirm Password'
            name='confirmPassword'
            type='password'
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
            error={confirmPassword.length > 0 && confirmPassword !== newPassword}
            placeholder='Re-enter your password'
            helperText={
              confirmPassword.length > 0 ? (
                confirmPassword === newPassword ? (
                  <span style={{ color: "green" }}>Passwords match</span>
                ) : (
                  <span style={{ color: "red" }}>Passwords do not match</span>
                )
              ) : (
                ""
              )
            }
          />
          <CommonButtons label='Reset Password' type='submit' variant='primary' className=' mx-auto justify-center py-3 mt-2' />
        </form>
      </div>
      <ToastContainer />
    </div>
  );
};

export default ResetPassword;
